module.exports = __webpack_public_path__ + "static/media/portfolio-website.2401f895.md";